import * as React from 'react';
import Container from '@mui/material/Container';
import Copyright from "../component/Copyright";
import { CssBaseline } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { processReturnInfo } from '../lib/api';


/**
 * 支付宝同步返回页面（只用作支付宝返回，内部组件请不要使用）
 * @returns 
 */
export  function AlipayReturnPage() {
	//const [params] = useSearchParams()
  // const outTradeNo = params.get("out_trade_no");
  // const tradeNo = params.get("trade_no");
  const {search} = useLocation();
  React.useEffect(()=>{
    processReturnInfo(search.substring(1)).then(()=>{
      window.opener = null;
      window.open('', '_self', '');        //其他浏览器
      window.close();
    });
  })
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}